import { render, staticRenderFns } from "./UpgradeAnnouncement.vue?vue&type=template&id=1a0b546b&scoped=true"
import script from "./UpgradeAnnouncement.vue?vue&type=script&lang=js"
export * from "./UpgradeAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./UpgradeAnnouncement.vue?vue&type=style&index=0&id=1a0b546b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b546b",
  null
  
)

export default component.exports